<template>
    <div class="account">
        <div class="account__content">
        <div class="my-vespa" v-if="data.items">
            <div class="back-btn" @click="$emit('cancel')">
                <div>
                    <img v-svg-inline src="@/assets/img/icons/arrow_left.svg"/>
                </div>
                Zurück
            </div>

            <h1>{{ data.items[0].productName }}</h1>
            <!-- <div class="vespa-id">{vespaById.vehicleNumber && `Rahmennummer: ${vespaById.vehicleNumber}`}</div> -->
            <div class="my-vespa__grid">
                <div class="my-vespa__slider">
                    <Carousel :items="[data.items[0].thumbnail]" />
                </div>
                <div class="my-vespa__info-block">
                    <div>
                        <img v-svg-inline src="@/assets/img/icons/alarm.svg" />
                    </div>
                    <h3>Motolino Notfall Service</h3>
                    <p><a :href="emergencyNumber">{{emergencyNumber}}</a></p>
                </div>
                <div class="my-vespa__info-block">
                    <h3>Service Daten</h3>
                    <div class="info-row">
                        <span>Vespa gekauft am:</span>
                        <div>{{ date(data.orderDate) }}</div>
                    </div>
                    <div class="info-row">
                        <span>Nächster empfohlener Service:</span>
                        <div>{{ date(data.serviceDate) }}</div>
                        <span>oder nach den ersten 1000 km</span>
                    </div>
                    <div class="info-row">
                        <span>Nach dem ersten Service empfehlen wir Services im Jahrestakt oder nach jeweils 5000 km</span>
                    </div>
                </div>
            </div>
            <h2 class="h1">Ihre Bestellung #{{ data.orderNr }}</h2>
            <Order :order="data" v-if="data"></Order>
        </div>
    </div>
    </div>
</template>

<script>
import { date } from "@/services/Formatters";
import {Al} from "../helpers/async.helper";
import axios from "axios";
import {useRoute, useRouter} from "vue-router";
import Order from "./Order"
import Dealer from '@/state/Dealership';

export default {
    components: {Order},
    data: () => ({
        data: {},
        location: null,
        loading: false,
        error: null,
        warrantyState: null,
        warrantyActivated: null,
        emergencyNumber: ''
    }),
    mounted() {
        this.init();
    },
    methods: {
        date,
        async init() {
            const route = useRoute();
            const router = useRouter();

            this.emergencyNumber = Dealer.getEmergencyNumber();

            const orderNumber = route.params.orderNumber;
            if (orderNumber === null) {
                router.push('/');
            }

            const result = await Al(axios.get(`${process.env.VUE_APP_API_BASEURL}/order/${orderNumber}`, { headers: { 'X-Digitalino-Merchant': Dealer.getMerchantId() } }));
            if (result.status === 200) {
                const order = result.data;
                this.data = {
                    ...order
                };
            }
        }
    }
}
</script>

<style src="@/assets/scss/views/MyVespa.scss" lang="scss"></style>
<style src="@/assets/scss/views/Account.scss" lang="scss"></style>
